exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tabs-view-container[data-v-57015451] {\n  display: inline-block;\n  vertical-align: top;\n  margin-left: 10px;\n}\n.tabs-view-container .tabs-view[data-v-57015451] {\n    margin-left: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-57015451","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/layout/TabsView.vue
// module id = 83ef
// module chunks = 212